import { SearchResultFlightDirectionFragment } from '@websky/graphql';
import { SelectedFare } from '../../../../DesktopFlight/types';
import { ExchangeFlight } from '../model/types';

export function transformSelectedFlights(
	selectedFlights: ExchangeFlight[],
	flightDirections: SearchResultFlightDirectionFragment[]
): SelectedFare[] {
	if (!selectedFlights.length) {
		return [];
	}

	const flightsMap = new Map<string, SelectedFare>();

	selectedFlights.forEach((selectedFlight, leg) => {
		const flightsOnSegment = flightDirections[leg]?.legs ?? [];

		flightsOnSegment.forEach(flightOnLeg =>
			flightOnLeg.pricesForFareGroups.forEach(fareGroup => {
				const fareGroupId = fareGroup.fareFamily?.id;
				const flightKey = `${fareGroupId}/${leg}`;

				if (
					fareGroupId === selectedFlight.groupId &&
					fareGroup.prices.some(price => price.flight.id === selectedFlight.priceId)
				) {
					flightsMap.set(flightKey, {
						fareGroupId,
						fareName: fareGroup.fareFamily.title,
						fareFamily: fareGroup.fareFamily,
						flightInfo: flightOnLeg,
						prices: [...(flightsMap.get(fareGroupId)?.prices ?? []), ...fareGroup.prices]
					});
				}
			})
		);
	});

	return [...flightsMap.values()];
}
